import { tocktix } from '@tock/protos/dist/types/clowncar';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

import { protoLib } from '@tock/coretypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const { ListResponseProto } = protoLib.lookup('tocktix.lib') as any;

const { ManualAchRequest } = protos;

export function startBankTransfer(request: tocktix.proto.clowncar.ManualAchRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/internal/ach',
      request: ManualAchRequest.fromObject(request),
      type: ClowncarAppConstants.BANK_TRANSFER_START,
      toast: 'Bank transfer request accepted. Will need approval before being sent.',
    },
  };
}

export function parseFileToAchRequests(fileToUpload: File): ApiAction {
  return {
    TockApi: {
      postFile: '/internal/ach/parse',
      request: fileToUpload,
      type: ClowncarAppConstants.NULL,
      responseType: ListResponseProto,
    },
  };
}

export function getBankTransferDetails(achTransferId: number): ApiAction {
  return {
    TockApi: {
      getProto: `/internal/ach?id=${achTransferId}`,
      type: ClowncarAppConstants.BANK_TRANSFER_FETCH,
    },
  };
}

export function approveBankTransfer(achTransferId: number): ApiAction {
  return {
    TockApi: {
      getProto: `/internal/ach/approve?id=${achTransferId}`,
      type: ClowncarAppConstants.BANK_TRANSFER_APPROVE,
      toast: 'Bank transfer approved and sent. Check your email for details.',
    },
  };
}
